import { z } from 'zod'

/**
 * What the licence route takes in its search: `?recheck=true` opens the flow on a customer who
 * already has a licence on file. The route validates with it and the screen parses with it, so
 * the two cannot disagree about the flag.
 */
export const licenceCaptureSearchSchema = z.object({ recheck: z.boolean().optional() })
